module.exports = __webpack_public_path__ + "static/img/banner-text.1fe9fb20.png";